import { API_CONFIG, getHeaders } from '../config/api';
import { internalApi } from './internalApi';

/** Balance from API is assumed to be in minor units (paise); adjust if your API returns rupees. */
export function formatWalletBalanceMinor(amount) {
  if (amount == null || Number.isNaN(Number(amount))) return '—';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number(amount) / 100);
}

export const channelService = {
  getChannelWallet: async (channelId) => {
    const response = await internalApi.get(
      API_CONFIG.ENDPOINTS.CHANNEL_WALLET(channelId),
      { headers: getHeaders(undefined, channelId) }
    );
    return response.data;
  },

  /**
   * @param {string} channelId
   * @param {Record<string, string | number | undefined>} [params] page, limit, from_ms, to_ms, reference_type, event_type, transaction_type
   */
  getWalletStatement: async (channelId, params = {}) => {
    const response = await internalApi.get(
      API_CONFIG.ENDPOINTS.CHANNEL_WALLET_STATEMENT(channelId),
      { headers: getHeaders(undefined, channelId), params }
    );
    return response.data;
  },
};
